export const NON_CONFORMITY_CATEGORIES = {
  MAJOR: 'major',
  MINOR: 'minor',
  OBSERVATION: 'observation',
  OPPORTUNITY: 'opportunity',
} as const

export const NON_CONFORMITY_AUDIT_TYPES = {
  INTERNAL: 'internal',
  EXTERNAL: 'external',
} as const

export const MAX_NON_CONFORMITY_EFFECTIVENESS = 5
export const MIN_NON_CONFORMITY_EFFECTIVENESS = 0
